export default () => {
  if (process.client) {
    const setLang = () => {
      document.documentElement.setAttribute('lang', 'vi');
    };
    setLang();

    // Theo dõi mọi thay đổi thuộc tính lang trên thẻ html
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'lang' &&
          document.documentElement.getAttribute('lang') !== 'vi'
        ) {
          setLang();
        }
      });
    });

    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });
  }
}
